import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, MessageCircle, Star } from "lucide-react";
import { BUSINESS, AREAS } from "@/lib/business";
import Logo from "@/components/site/Logo";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-slate-100 bg-white" data-testid="site-footer">
      <div className="container-x py-12 grid gap-10 md:grid-cols-4">
        <div>
          <Logo size={64} />
          <p className="text-sm text-slate-600 leading-relaxed mt-4">The Phone, iPad, Mac & Computer Repair Specialist — Walk-in & mobile call-out across Eastleigh, Southampton, Hampshire & Surrey.</p>
          <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-slate-50 px-3 py-1.5 text-sm">
            <Star className="h-4 w-4 text-amber-500 fill-amber-500" />
            <span className="font-semibold">{BUSINESS.rating.score}</span>
            <span className="text-slate-500">({BUSINESS.rating.count} Google reviews)</span>
          </div>
        </div>
        <div>
          <h3 className="font-semibold text-slate-900 mb-3">Services</h3>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link className="hover:text-slate-900" to="/services">iPhone Repair</Link></li>
            <li><Link className="hover:text-slate-900" to="/services">Android Repair</Link></li>
            <li><Link className="hover:text-slate-900" to="/services">iPad & Tablet Repair</Link></li>
            <li><Link className="hover:text-slate-900" to="/services">MacBook & PC Repair</Link></li>
            <li><Link className="hover:text-slate-900" to="/services">Battery & Water Damage</Link></li>
            <li><Link className="hover:text-slate-900" to="/services">Buy & Sell Phones</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="font-semibold text-slate-900 mb-3">Areas we cover</h3>
          <ul className="space-y-2 text-sm text-slate-600 columns-2">
            {AREAS.slice(0, 10).map(a => (
              <li key={a.slug}><Link className="hover:text-slate-900" to={`/areas/${a.slug}`}>{a.name}</Link></li>
            ))}
          </ul>
          <Link to="/areas" className="link-magenta text-sm font-semibold mt-3 inline-block">All areas →</Link>
        </div>
        <div>
          <h3 className="font-semibold text-slate-900 mb-3">Get in touch</h3>
          <ul className="space-y-3 text-sm text-slate-700">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5" style={{ color: "var(--icrack-magenta)" }} /><span>{BUSINESS.address.line1}, {BUSINESS.address.city}, {BUSINESS.address.postcode}</span></li>
            {BUSINESS.phones.map(p => (
              <li key={p.tel} className="flex items-center gap-2">
                <Phone className="h-4 w-4" style={{ color: "var(--icrack-magenta)" }} />
                <a className="hover:text-slate-900" href={`tel:${p.tel}`}>{p.display}</a>
              </li>
            ))}
            <li className="flex items-center gap-2"><Mail className="h-4 w-4" style={{ color: "var(--icrack-magenta)" }} /><a className="hover:text-slate-900" href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a></li>
            <li className="flex items-center gap-2"><MessageCircle className="h-4 w-4 text-green-600" /><a className="hover:text-slate-900" href={BUSINESS.whatsapp.href} target="_blank" rel="noreferrer">WhatsApp us</a></li>
            <li className="flex items-start gap-2"><Clock className="h-4 w-4 mt-0.5" style={{ color: "var(--icrack-magenta)" }} /><span>Mon–Sat 9:00–18:00 • Sun 10:00–17:00</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-100">
        <div className="container-x py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} iCrack Solutions. All rights reserved.</p>
          <p>94 Market Street, Eastleigh, Hampshire, SO50 5RE, UK</p>
        </div>
      </div>
    </footer>
  );
}
